import { jsx as e } from "react/jsx-runtime";
function o(l) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...l, children: /* @__PURE__ */ e(
    "path",
    {
      clipRule: "evenodd",
      d: "M13.2 5.6a1.6 1.6 0 11-3.2 0 1.6 1.6 0 013.2 0zm0 6.4a1.6 1.6 0 11-3.2 0 1.6 1.6 0 013.2 0zm-1.6 8a1.6 1.6 0 100-3.2 1.6 1.6 0 000 3.2z",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ) });
}
export {
  o as default
};
